import React from 'react';

const PlatformComparison = () => {
  const handleGetStarted = () => {
    window.open('https://calendly.com/superhunt/45min', '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-white font-mono font-bold text-2xl sm:text-4xl">D</span>
              </div>
              <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
                Deel
              </span>
            </div>
            
            <div className="text-gray-400 text-xl sm:text-3xl">+</div>
            
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-600 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-white font-mono font-bold text-2xl sm:text-4xl">U</span>
              </div>
              <span className="bg-gradient-to-r from-green-600 to-green-800 bg-clip-text text-transparent">
                Upwork
              </span>
            </div>
            
            <div className="text-orange-500 text-xl sm:text-3xl">=</div>
            
            <div className="flex items-center space-x-2">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
                <span className="text-white font-mono font-bold text-sm sm:text-xl">&lt;tod&gt;</span>
              </div>
              <span className="bg-gradient-to-r from-orange-500 to-pink-500 bg-clip-text text-transparent">
                TOD Gigs
              </span>
            </div>
          </div>
          
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            The perfect synthesis of <span className="font-semibold text-blue-600">global hiring excellence</span> and 
            <span className="font-semibold text-green-600"> expert delivery mastery</span>
          </p>
        </div>

        {/* Comparison Cards */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Deel Card */}
          <div className="relative">
            <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-blue-100 hover:border-blue-300 transition-all duration-300 hover:shadow-2xl h-full">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-blue-600 text-white px-6 py-3 rounded-2xl text-2xl font-bold shadow-lg">
                  DEEL HIRING
                </div>
              </div>
              
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">🌍</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Global Payroll Leader</h3>
                <p className="text-gray-600">Compliance & Hiring Excellence</p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Smart Hiring via SuperHunt</p>
                    <p className="text-sm text-gray-600">Systematic sourcing of passive candidates</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Partnership with Antal India</p>
                    <p className="text-sm text-gray-600">Global payroll & compliance solutions</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Job Security Guarantee</p>
                    <p className="text-sm text-gray-600">Regardless of your funding stage</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Plus Sign */}
          <div className="flex items-center justify-center">
            <div className="w-20 h-20 bg-gradient-to-br from-orange-400 to-pink-500 rounded-full flex items-center justify-center shadow-2xl">
              <span className="text-4xl font-bold text-white">+</span>
            </div>
          </div>

          {/* Upwork Card */}
          <div className="relative">
            <div className="bg-white rounded-3xl shadow-xl p-8 border-2 border-green-100 hover:border-green-300 transition-all duration-300 hover:shadow-2xl h-full">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-green-600 text-white px-6 py-3 rounded-2xl text-2xl font-bold shadow-lg">
                  UPWORK DELIVERY
                </div>
              </div>
              
              <div className="text-center mb-8">
                <div className="text-6xl mb-4">⚡</div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Gig Execution Platform</h3>
                <p className="text-gray-600">Expert Delivery Excellence</p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Domain + AI Expert Oversight</p>
                    <p className="text-sm text-gray-600">Expert-driven quality assurance</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Project Delivery Management</p>
                    <p className="text-sm text-gray-600">End-to-end delivery excellence</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                    </svg>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Quality Assurance Processes</p>
                    <p className="text-sm text-gray-600">Continuous monitoring & improvement</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Result Card */}
        <div className="text-center">
          <div className="inline-block bg-gradient-to-br from-orange-500 via-pink-500 to-purple-600 p-1 rounded-3xl shadow-2xl">
            <div className="bg-white rounded-3xl p-12">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-orange-500 to-pink-500 text-white px-8 py-4 rounded-2xl text-3xl font-bold shadow-lg">
                  = TOD GIGS
                </div>
              </div>
              
              <div className="text-6xl mb-6">🚀</div>
              
              <h3 className="text-3xl font-bold bg-gradient-to-r from-orange-500 to-pink-500 bg-clip-text text-transparent mb-4">
                The Perfect Synthesis
              </h3>
              
              <p className="text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
                Combining hiring excellence with delivery mastery, powered by AI and domain expertise
              </p>

              <div className="grid md:grid-cols-2 gap-8 mb-8">
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-2xl">
                  <h4 className="font-bold text-blue-900 mb-2">Hiring Excellence</h4>
                  <p className="text-blue-700 text-sm">Global compliance + Smart sourcing + Job security</p>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-2xl">
                  <h4 className="font-bold text-green-900 mb-2">Delivery Mastery</h4>
                  <p className="text-green-700 text-sm">Expert oversight + Quality assurance + Project management</p>
                </div>
              </div>

              <button
                onClick={handleGetStarted}
                className="bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-12 py-4 rounded-2xl font-bold text-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
              >
                Experience TOD Gigs
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlatformComparison;